module.exports = __webpack_public_path__ + "static/Chapter-Regular-4b2eb9d431ec6db0960289dbc70646c0.woff2";